import React from 'react';
import {Link} from 'react-router-dom';
import articles from '../data/articles.json'; 

const RecentArticles = (props)=>{
	
	// Filter data with recent articles only
	let recent = articles.articles.filter((article) => {
		return article.recent === true;
	});
	//console.log(recent)

	return (
		<div className="recent-articles container-fluid">
			<div className="container p-0">

				<h2 className="text-center">Recent Articles</h2>

				<div className="card-deck">

					{/* Map recent blog articles*/}
					{
						recent.map((obj, i)=>{
							return (
								<div className="card" key={i}>
									<div className="img-holder" style={{'background': 'url('+obj.image+') top center no-repeat', 'backgroundSize': 'cover'}}></div>
									<div className="card-body">
										<h4 className="card-title">
											{/* blog auto url, replace space with hyphen via regex then lowercase */}
											<Link to={"/blog/"+obj.title.replace(/[\W_]/g, " ").replace(/\s+/g, '-').toLowerCase()}>{obj.title}</Link>
										</h4>
										<p className="card-text"><small className="text-mute">{obj.author}</small></p>
										{/* Max 220 chars, then remove html strings via regex */}
										<p className="card-text">{obj.content.substring(0, 220).replace(/<[^>]+>/g, '')} [...]</p>
									</div>
									<div className="card-footer">
										<Link to={"/blog/"+obj.title.replace(/[\W_]/g, " ").replace(/\s+/g, '-').toLowerCase()} className="btn btn-default">Read more ...</Link>
									</div>
								</div>
							)
						})
					}

				</div>

				<div className="text-center">
					<Link to="/blog" className="btn btn-lightblue mx-auto my-5">View All</Link>
				</div>

			</div>
		</div>
	);
}

export default RecentArticles;


// WEBPACK FOOTER //
// ./src/view/RecentArticles.js